import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import "./gallery.css";

import { gallery } from "gallery.js";

const Gallery = () => {
	const swiperRef = useRef(null);

	const images = [...gallery];

	return (
		<div id="portfolio" className="rts-case-studyes rts-section-gapTop bg-white">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="title-area-center">
							<p className="pre">
								<span>Cartongessi</span> su Misura
							</p>
							<h2 className="title">Dai uno sguardo ai nostri lavori</h2>
						</div>
					</div>
				</div>
			</div>
			<div className="container mt--45">
				<div className="row">
					<div className="col-lg-12 col-md-12 col-sm-12 col-12">
						<Swiper
							onSwiper={(swiper) => (swiperRef.current = swiper)}
							modules={[Autoplay]}
							autoplay={{ delay: 3000, disableOnInteraction: false }}
							loop={true}
							spaceBetween={20}
							breakpoints={{
								320: { slidesPerView: 1, spaceBetween: 10 },
								768: { slidesPerView: 2, spaceBetween: 15 },
								1024: { slidesPerView: 4, spaceBetween: 20 },
							}}>
							{images.map((element, index) => (
								<SwiperSlide key={"gallery-" + index}>
									<div className="portfolio-slide">
										<a href={element.img} target="_blank">
											<img src={element.img} alt={element.alt} />
										</a>
									</div>
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Gallery;
